import gql from 'graphql-tag';
export default gql`
  mutation UpdatePhoneById($input: UpdatePhoneByIdInput!) {
    updatePhoneById(input: $input) {
      clientMutationId
    }
  }
`;
